import {CircleAlert, PauseCircle} from 'lucide-react';
import {DestinationRefusal, forwardingRefusalMessage} from '../../utils/callRestrictions/apiErrors';

const icon = '!p-0 shrink-0 !text-current';

interface PausedProps {
    /** The line's name, e.g. "Office". */
    lineName?: string;
    /** Whether the line has voicemail: paused forwards fall through to it, otherwise the call ends. */
    voicemail: boolean;
}

/** Board ForwardingBlocked: shown when the call-rules GET says forwarding is paused. */
export const ForwardingPausedBanner = ({lineName, voicemail}: PausedProps) => (
    <div role="alert" data-testid="forwarding-paused" className="flex gap-2.5 rounded-card bg-warning-tint p-3">
        <PauseCircle size={18} aria-hidden="true" className={`${icon} mt-px text-warning-ink`}/>
        <div className="flex flex-col gap-1">
            <div className="text-callout font-semibold text-warning-ink">Forwarding is paused</div>
            <div className="text-footnote text-ink-muted-strong">
                Calls to {lineName || 'this line'} aren’t forwarded because the number is no longer authorized.{' '}
                {voicemail ? 'Callers go to voicemail instead.' : 'Callers hear an announcement and the call ends.'}
            </div>
        </div>
    </div>
);

/** The 422 DESTINATION_NOT_AUTHORIZED under a forwarding number. */
export const ForwardRefusalText = ({refusal, id}: {refusal: DestinationRefusal; id?: string}) => (
    <p id={id} role="alert" data-testid="forward-refusal" className="m-0 mt-2 flex items-start gap-1.5 text-footnote text-danger-ink">
        <CircleAlert size={14} aria-hidden="true" className={`${icon} mt-0.5`}/>
        <span>{forwardingRefusalMessage(refusal)}</span>
    </p>
);
